import posthog from "posthog-js";

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST =
  process.env.REACT_APP_POSTHOG_HOST || "https://eu.i.posthog.com";

let isInitialized = false;

export function initAnalytics() {
  if (!POSTHOG_KEY || isInitialized) return;

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: true,
    autocapture: true,
    persistence: "localStorage+cookie",
    loaded: () => {
      console.log("PostHog initialized", POSTHOG_HOST);
    }
  });

  window.posthog = posthog;
  isInitialized = true;
}

function getUserId(user) {
  return user?.id || user?._id || user?.email || "";
}

function getCompanyId(user) {
  return user?.companyId || user?.company?._id || user?.company?.id || "";
}

function getCompanyName(user) {
  return user?.companyName || user?.company?.name || "";
}

function getCompanyPlan(user) {
  return (
    user?.companyPlan ||
    user?.company?.plan ||
    user?.subscription?.planKey ||
    user?.plan ||
    user?.subscriptionPlan ||
    ""
  );
}

function getCommonProperties(user = {}) {
  return {
    app: "ecovanta",
    userId: getUserId(user),
    email: user?.email || "",
    name: user?.name || user?.fullName || "",
    role: user?.role || "",
    plan: getCompanyPlan(user),
    userPlan: user?.userPlan || user?.plan || "",
    companyId: getCompanyId(user),
    companyName: getCompanyName(user),
    companyPlan: getCompanyPlan(user),
    subscriptionStatus:
      user?.subscriptionStatus ||
      user?.subscription?.status ||
      "",
    billingCycle:
      user?.billingCycle ||
      user?.subscription?.billingCycle ||
      "",
    sector: user?.sector || user?.company?.sector || "",
    companySize: user?.companySize || user?.company?.companySize || ""
  };
}

export function identifyUser(user) {
  if (!POSTHOG_KEY || !user) return;

  const distinctId = getUserId(user);

  if (!distinctId) return;

  initAnalytics();

  const properties = getCommonProperties(user);

  posthog.identify(distinctId, properties);

  const companyId = getCompanyId(user);

  if (companyId) {
    posthog.group("company", companyId, {
      name: getCompanyName(user),
      plan: getCompanyPlan(user),
      sector: user?.sector || user?.company?.sector || "",
      companySize:
        user?.companySize ||
        user?.company?.companySize ||
        "",
      subscriptionStatus:
        user?.subscriptionStatus ||
        user?.subscription?.status ||
        ""
    });
  }
}

export function trackEvent(eventName, properties = {}) {
  if (!POSTHOG_KEY || !eventName) return;

  initAnalytics();

  posthog.capture(eventName, {
    app: "ecovanta",
    ...properties
  });
}

export function trackUserEvent(eventName, user, properties = {}) {
  if (!POSTHOG_KEY || !eventName) return;

  initAnalytics();

  posthog.capture(eventName, {
    ...getCommonProperties(user),
    ...properties
  });
}

export const analyticsEvents = {
  WORKSPACE_OPENED: "workspace_opened",
  FEATURE_LOCKED_CLICKED: "feature_locked_clicked",

  LEAD_CREATED: "lead_created",
  LEAD_UPDATED: "lead_updated",
  LEAD_STAGE_UPDATED: "lead_stage_updated",
  MEETING_BRIEF_GENERATED: "meeting_brief_generated",

  DOCUMENT_UPLOADED: "document_uploaded",
  DOCUMENT_DELETED: "document_deleted",
  DOCUMENT_ANALYZED: "document_analyzed",

  REPORT_CREATED: "report_created",
  REPORT_UPDATED: "report_updated",
  REPORT_EXPORTED_PDF: "report_exported_pdf",

  SUBSCRIPTION_UPGRADED: "subscription_upgraded",
  SUBSCRIPTION_CHANGED: "subscription_changed",
  SUBSCRIPTION_CANCELLED: "subscription_cancelled",
  CREDITS_PURCHASED: "credits_purchased"
};